<template>
  <v-row class="px-2">
    <v-col cols="12" sm="12" md="12" class="text-center font-weight-bold d-print-block">
      Статистика  полученных писем  по регионам с
      <template>
        {{ startFilterDisplayValue }}
      </template>
      по
      <template>
        {{ endFilterDisplayValue }}
      </template>
    </v-col>
    <v-col cols="12" md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.isAllClientsSelected"
                :items="filterOptions"
                label="Выбрать все организации"

      />
    </v-col>
    <v-col cols="12" md="4" class="d-print-none">
      <v-select
          :disabled="filters.isAllClientsSelected"
          v-model="filters.clients"
          :items="clientsOptions()"
          label="Выберите организации"
          multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2" small style="background-color: #111; color: white; ">
            <span>{{ item.text }}</span>
          </v-chip>
          <span
              v-if="index === 2"
              class="text-grey text-caption align-self-center"
          >
          (+{{ filters.clients.length - 2 }} другие)
          </span>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" sm="3"  md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.isArchive"
                :items="archiveOptions"
                label="Выбрать версию"

      />
    </v-col>
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterStartMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Начало пероида"
              v-model="startFilterDisplayValue"
              readonly

              v-on="on"
              flat
          />

        </template>
        <v-date-picker
            v-model="filters.start"
            @change="onFilterStartChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7)&&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="2" class="d-print-none d-flex align-center justify-center justify-md-end">
      <v-menu
          v-model="filterEndMenu"
          transition="scale-transition"
          offset-y
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Конец пероида"
              v-model="endFilterDisplayValue"
              readonly

              v-on="on"
              flat
          />
        </template>
        <v-date-picker
            v-model="filters.end"
            @change="onFilterEndChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="(date) => {
              if (this.allowedFullAccessToPeriod) {
                return true
              }

              const currentDate = new Date();
              const lastMonth = new Date();
              lastMonth.setMonth(currentDate.getMonth() - -1);
              const secondToLastMonth = new Date();
              secondToLastMonth.setMonth(currentDate.getMonth() - 2);

              return date <= lastMonth.toISOString().substr(0, 7) &&
              date >= secondToLastMonth.toISOString().substr(0, 7) &&
              date <= new Date().toISOString().substr(0, 10);
            }"
        />
      </v-menu>
    </v-col>
    <v-col cols="12" md="12" class="d-flex justify-end d-print-none">
      <v-btn @click="showFilter()" :to="{name: 'report-perform', params: {filters: filters}}" color="danger" class="ml-2 mr-2" large>Назад</v-btn>
      <v-btn @click="onRefreshClicked" color="primary me-2" large :disabled="disableRefreshButton" >Обновить</v-btn>
      <v-btn @click="onPrintClicked" color="primary" large>Распечатать</v-btn>
    </v-col>
    <v-col cols="12">
      <template>
        <table>
          <thead>
          <tr style="background-color: aliceblue;">
            <th rowspan="2">Район</th>
            <th rowspan="2" class="text-center filter-header">Принято за период</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(0) }" :style="{ backgroundColor: filters.selectedFilters.includes(0) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(0)" class="text-center filter-header">Доставлен</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(1) }" :style="{ backgroundColor: filters.selectedFilters.includes(1) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(1)" class="text-center filter-header">Адресат умер</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(2)" class="text-center filter-header">Адресат по указанному адресу не проживает</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(3)" class="text-center filter-header">Указан не полный адрес</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(4)" class="text-center filter-header">Адресат от получения отказался</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(5)" class="text-center filter-header">Нет дома</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(6)" class="text-center filter-header">На явился по извещению</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(7)" class="text-center filter-header">Адрес не определен</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(8)" class="text-center filter-header">Попытка вручения</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(9)" class="text-center filter-header">По указанному адресу организация не найдена</th>
            <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(10) }" :style="{ backgroundColor: filters.selectedFilters.includes(10) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(10)" class="text-center filter-header">Остаток</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.area.id">
            <v-btn :class="{ 'd-print-none': !filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: filters.selectedAreas.includes(item.area.id) ? 'aliceblue' : '#e5e5e5' }" @click="toggleArea(item.area.id)" class="d-flex justify-space-between" style="height: 40px; width: 100%; background-color: aliceblue; border: 1px solid black; text-align: center">
              {{ item.area.name }}
            </v-btn>
            <td :class="{ 'd-print-none': !filters.selectedAreas.includes(item.area.id), 'column': filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.received)">{{ item.received }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(0), 'column': filters.selectedFilters.includes(0) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(0) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.successDelivered)">{{ item.successDelivered }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(1), 'column': filters.selectedFilters.includes(1) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(1) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.receiverDead)">{{ item.receiverDead }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2), 'column': filters.selectedFilters.includes(2) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(2) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.receiverNotLivesThere)">{{ item.receiverNotLivesThere }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3), 'column': filters.selectedFilters.includes(3) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(3) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.incompleteAddress)">{{ item.incompleteAddress }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4), 'column': filters.selectedFilters.includes(4) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(4) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.receiverRefuse)">{{ item.receiverRefuse }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5), 'column': filters.selectedFilters.includes(5) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(5) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.notAtHome)">{{ item.notAtHome }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6), 'column': filters.selectedFilters.includes(6) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(6) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.didntAppearOnNotice)">{{ item.didntAppearOnNotice }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7), 'column': filters.selectedFilters.includes(7) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(7) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.defect)">{{ item.defect }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8), 'column': filters.selectedFilters.includes(8) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(8) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.tryPerform)">{{ item.tryPerform }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9), 'column': filters.selectedFilters.includes(9) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(9) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.organizationWithGivenAddressNotFound)">{{ item.organizationWithGivenAddressNotFound }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(10), 'column': filters.selectedFilters.includes(10) && filters.selectedAreas.includes(item.area.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(10) || !filters.selectedAreas.includes(item.area.id) ? '#e5e5e5' : '' }" @click="itemClicked(item.rest)">{{ item.rest && filters.selectedFilters.includes(10) && filters.selectedAreas.includes(item.area.id) ? item.rest : '' }}</td>
          </tr>
          <tr style="background-color: aliceblue; color: black; font-weight: bold">
            <td style="height: 40px; text-align: center">Общее</td>
            <td>{{ totals.received }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(0) }" :style="{ backgroundColor: filters.selectedFilters.includes(0) ? 'aliceblue' : '#e5e5e5' }">{{ totals.successDelivered }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(1) }" :style="{ backgroundColor: filters.selectedFilters.includes(1) ? 'aliceblue' : '#e5e5e5' }">{{ totals.receiverDead }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ totals.receiverNotLivesThere }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ totals.incompleteAddress }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }">{{ totals.receiverRefuse }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }">{{ totals.notAtHome }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }">{{ totals.didntAppearOnNotice }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }">{{ totals.defect }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }">{{ totals.tryPerform }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(9) }" :style="{ backgroundColor: filters.selectedFilters.includes(9) ? 'aliceblue' : '#e5e5e5' }">{{ totals.organizationWithGivenAddressNotFound }}</td>
            <td :class="{ 'd-print-none': !filters.selectedFilters.includes(10) }" :style="{ backgroundColor: filters.selectedFilters.includes(10) ? 'aliceblue' : '#e5e5e5' }">{{ totals.rest }}</td>
          </tr>
          </tbody>
        </table>
      </template>
    </v-col>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import {required} from 'vuelidate/lib/validators'
import {DateLimitForFilters} from "@/settings/server";
import {clients} from "@/helpers/constants";

export default {
  name: "PerformsAreaReport",
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    regionId: {
      type: Number,
      default: null
    },
    pfilters: {
      start: null,
      end: null,
      date: null,
      selectedFilters: [],
      isAllClientsSelected: false,
      isArchive: 1,
      clients: []
    }
  },
  data() {
    return {
      filters: {
        start: null,
        end: null,
        date: null,
        selectedFilters: [],
        selectedAreas: this.$store.getters.appAreas.filter(i => i.region.id === this.regionId ? this.regionId : this.$route.params?.regionId).map(i => i.id),
        isAllClientsSelected: false,
        isArchive: 1,
        clients: []
      },
      archiveOptions: [
        { text: '1', value: 1 }
      ],
      filterOptions: [
        { text: 'Нет', value: false },
        { text: 'Да', value: true },
      ],
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,
      dateFilterDisplayValue: null,
      filterDateMenu: false,
    }
  },
  computed: {
    totals() {
      let received = 0;
      let successDelivered = null;
      let receiverDead = null;
      let receiverNotLivesThere = null;
      let incompleteAddress = null;
      let receiverRefuse = null;
      let notAtHome = null;
      let didntAppearOnNotice = null;
      let defect = null;
      let tryPerform = null;
      let organizationWithGivenAddressNotFound = null;
      let rest = null;

      _.each(this.items, item => {
        received += item.received ? item.received : 0;
        if(item.successDelivered !== null)
          successDelivered += item.successDelivered
        if(item.receiverDead !== null)
          receiverDead += item.receiverDead
        if(item.receiverNotLivesThere !== null)
          receiverNotLivesThere += item.receiverNotLivesThere
        if(item.incompleteAddress !== null)
          incompleteAddress += item.incompleteAddress
        if(item.receiverRefuse !== null)
          receiverRefuse += item.receiverRefuse
        if(item.notAtHome !== null)
          notAtHome += item.notAtHome
        if(item.didntAppearOnNotice !== null)
          didntAppearOnNotice += item.didntAppearOnNotice
        if(item.defect !== null)
          defect += item.defect
        if(item.tryPerform !== null)
          tryPerform += item.tryPerform
        if(item.organizationWithGivenAddressNotFound !== null)
          organizationWithGivenAddressNotFound += item.organizationWithGivenAddressNotFound
        if(item.rest !== null)
          rest += item.rest
      });

      return {
        received: received,
        successDelivered: successDelivered,
        receiverDead: receiverDead,
        receiverNotLivesThere: receiverNotLivesThere,
        incompleteAddress: incompleteAddress,
        receiverRefuse: receiverRefuse,
        notAtHome: notAtHome,
        didntAppearOnNotice: didntAppearOnNotice,
        defect: defect,
        tryPerform: tryPerform,
        organizationWithGivenAddressNotFound: organizationWithGivenAddressNotFound,
        rest: rest
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload() || this.$v.$invalid
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  validations: {
    filters: {
      start: {
        required
      },
      end: {
        required
      }
    }
  },
  methods: {
    showFilter(){
      this.$router.push({
        name: 'report-perform',
        params: { filters: this.filters }
      });
    },
    clientsOptions() {
      return clients
    },
    selectAllAreas() {
      const allAreasSelected = this.filters.selectedAreas.length === this.items.length;

      if (allAreasSelected) {
        this.filters.selectedAreas = [];
      } else {
        this.filters.selectedAreas = this.items.map(item => item.area.id);
      }
    },
    rest(item){
      if(item.received !== null){
        return item.received - (
            (item.successDelivered || 0) +
            (item.receiverDead || 0) +
            (item.receiverNotLivesThere || 0) +
            (item.incompleteAddress || 0) +
            (item.receiverRefuse || 0) +
            (item.notAtHome || 0) +
            (item.didntAppearOnNotice || 0) +
            (item.defect || 0) +
            (item.tryPerform || 0) +
            (item.organizationWithGivenAddressNotFound || 0)
        );
      }
      return null;
    },
    toggleFilter(filterId) {
      const index = this.filters.selectedFilters.findIndex(id => id === filterId);
      if (index !== -1) {
        this.filters.selectedFilters.splice(index, 1);
      } else {
        this.filters.selectedFilters.push(filterId);
      }
    },
    toggleArea(areaId) {
      const index = this.filters.selectedAreas.findIndex(id => id === areaId);
      if (index !== -1) {
        this.filters.selectedAreas.splice(index, 1);
      } else {
        this.filters.selectedAreas.push(areaId);
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      console.log("Salom")
      // this.updateItems()
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },

    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    onPrintClicked() {
      window.print()
    }
  },
  created() {
    this.filters.start = this.$route.params?.filters?.start ?? Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.end = this.$route.params?.filters?.end ?? Moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')

    this.updateItems();
  }
}
</script>

<style scoped>
.filter-header {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.filter-header:hover{
  background-color: #dfe7ed;
}
.column {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.column:hover{
  background-color: #dfe7ed;
}
th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>
